<template>
    <DialogLayout>
        <h3 class="Modal__title">Créer une fiche employé</h3>
        <form @submit.prevent="handleSubmit" class="FormMaterial m-t-30">
            <div class="FormMaterial__group">
                <input placeholder=" " class="FormMaterial__input" type="text" id="name" name="name"
                       v-model="data.name">
                <label for="name">Nom / Prénom</label>
                <span v-if="errors.name">{{ errors.name[0] }}</span>
            </div>
            <div class="Form__group">
                <multiselect
                    class="Select"
                    placeholder="Sélectionnez une ou plusieurs formations"
                    open-direction="bottom"
                    :allow-empty="false"
                    :searchable="false"
                    :showLabels="false"
                    :options="formations"
                    :multiple="true"
                    v-model="data.formation_ids"
                    label="name">
                    <span slot="noOptions">Aucun élément.</span>
                </multiselect>
            </div>

            <div class="text-center m-t-30">
                <button :disabled="loading" type="submit" class="Btn Btn--primary Btn--gradient Btn--shadow">
                    <i v-if="loading" class="fas fa-spinner fa-spin"></i>
                    <span v-else>Valider</span>
                </button>
            </div>
        </form>
    </DialogLayout>
</template>

<script>
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import {actions, getters, mutations} from "../../../store";
    import Api from "../../../services/Api";
    import ModalBus from "../../../eventBus";
    import DialogLayout from "../Layouts/DialogLayout";

    export default {
        components: {DialogLayout, Multiselect},
        data: function () {
            return {
                data: {
                    name: null,
                    formation_ids: [],
                },
                loading:false,
                errors: {},
                isCreated: false
            }
        },
        computed: {
            formations: getters.formationsList
        },
        methods: {
            async handleSubmit() {
                try {
                    let {formation_ids, name} = this.data;
                    if(name.length < 2){
                        return;
                    }
                    this.loading = true;
                    const {data} = await Api.post('/folders', {
                        name: name,
                        formation_ids: formation_ids.map(item => item.id)
                    });
                    mutations.pushFolders([data]);
                    ModalBus.alertSuccess('Employé créé', 'Votre employé a bien été sauvegardé.');
                } catch (err) {
                    ModalBus.processingError();
                }
            }
        },
        created() {
            actions.fetchFormationsList();
        }
    }
</script>
